import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase.ts';

/** Felhasználók neve azonosító szerint. Akit az RLS nem enged olvasni, az nem kerül a térképre (a hívó tartalék szöveget ír). */
export function useProfilNevek(azonositok: (string | null)[]): Map<string, string> {
  const idk = [...new Set(azonositok.filter((x): x is string => x !== null))].sort();
  const lekeres = useQuery({
    queryKey: ['hibajegyek', 'nevek', idk],
    enabled: idk.length > 0,
    queryFn: async () => {
      const { data, error } = await supabase.from('profiles').select('user_id, nev, email').in('user_id', idk);
      if (error) throw error;
      return new Map(data.map((p) => [p.user_id, p.nev || p.email]));
    },
  });
  return lekeres.data ?? new Map();
}
